"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AnnotationUtil = _interopRequireDefault(require("./AnnotationUtil"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DOM_MODE_APPEND = 'append';
var DOM_MODE_INSERT = DOM_MODE_APPEND;

var AnnotationRenderer = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param {Element} element
   * @param {Array.<Annotation>} annotations
   * @param {AnnotationHelper} helper
   */
  function AnnotationRenderer(element, annotations, helper) {
    _classCallCheck(this, AnnotationRenderer);

    this.element = element;
    this.annotations = annotations;
    this.helper = helper;
    this.canvas = null;
    this.context = null;
    this.width = 0;
    this.height = 0;

    if (!this.element) {
      return;
    }

    if (this.element.tagName === 'CANVAS') {
      this._reuseCanvas();
    } else {
      this.domMode = DOM_MODE_INSERT;

      this._createCanvas();

      this.resize();
    }
  }
  /**
   * Create the canvas for the renderer
   */


  _createClass(AnnotationRenderer, [{
    key: "_createCanvas",
    value: function _createCanvas() {
      this.canvas = _AnnotationUtil["default"].createCanvasForElement(this.element, this.helper.options.devicePixelRatio, this.helper.options.append, this.domMode === DOM_MODE_INSERT);
      this.canvas.className += ' annotation-renderer';
      this.context = this.canvas.getContext('2d');
    }
  }, {
    key: "_reuseCanvas",
    value: function _reuseCanvas() {
      this.canvas = this.element;
      this.canvas.className += ' annotation-renderer';
      this.context = this.canvas.getContext('2d');
      var rect = this.canvas.getBoundingClientRect();
      this.width = rect.width * this.helper.options.devicePixelRatio;
      this.height = rect.height * this.helper.options.devicePixelRatio;
    }
  }, {
    key: "resize",
    value: function resize() {
      var rect = this.element.getBoundingClientRect();
      this.width = rect.width * this.helper.options.devicePixelRatio;
      this.height = rect.height * this.helper.options.devicePixelRatio;
      this.canvas.width = rect.width * this.helper.options.devicePixelRatio;
      this.canvas.height = rect.height * this.helper.options.devicePixelRatio;
      var canvasTop = 0;
      var canvasLeft = 0;

      if (this.canvas !== this.element) {
        if (this.domMode !== DOM_MODE_INSERT) {
          canvasTop = "".concat(this.element.offsetTop, "px");
          canvasLeft = "".concat(this.element.offsetLeft, "px");
        }

        this.canvas.style.width = "".concat(rect.width, "px");
        this.canvas.style.height = "".concat(rect.height, "px");
        this.canvas.style.top = canvasTop;
        this.canvas.style.left = canvasLeft;
      }

      this.render();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._destroyCanvas();
    }
    /**
     * Destroy canvas + references
     */

  }, {
    key: "_destroyCanvas",
    value: function _destroyCanvas() {
      this.context = null;
      this.element.parentNode.removeChild(this.canvas);
      this.canvas = null;
    }
    /**
     * Clear the canvas
     */

  }, {
    key: "clear",
    value: function clear() {
      if (this.context) {
        this.context.clearRect(0, 0, this.width, this.height);
      }
    }
    /**
     * Get annotation data from renderer
     * @returns {Array.<Annotation>}
     */

  }, {
    key: "getAnnotations",
    value: function getAnnotations() {
      return this.annotations;
    }
    /**
     * Update annotations for renderer
     * @param {Array.<Annotation>} annotations
     * @returns {AnnotationRenderer}
     */

  }, {
    key: "setAnnotations",
    value: function setAnnotations() {
      var annotations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.annotations = annotations;
      return this;
    }
  }]);

  return AnnotationRenderer;
}();

var _default = AnnotationRenderer;
exports["default"] = _default;